import { c as _c } from "react/compiler-runtime";
import { faroCoreApiClient } from "@api/faro-core-api-client";
import { useCompanyId } from "@context-providers/company-id-provider";
import { useEffect, useState } from "react";
/** A hook that fetches all the Stripe products in the company */
export function useStripeProducts() {
  const $ = _c(7);
  const companyId = useCompanyId();
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = [];
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const [stripeProducts, setStripeProducts] = useState(t0);
  const [isLoading, setIsLoading] = useState(true);
  let t1;
  let t2;
  if ($[1] !== companyId) {
    t1 = () => {
      const fetchStripeProducts = async function fetchStripeProducts() {
        const products = await faroCoreApiClient.company.getStripeProducts({
          companyId
        });
        if (products && products.length > 0) {
          setStripeProducts(products);
        }
        setIsLoading(false);
      };
      fetchStripeProducts();
    };
    t2 = [companyId];
    $[1] = companyId;
    $[2] = t1;
    $[3] = t2;
  } else {
    t1 = $[2];
    t2 = $[3];
  }
  useEffect(t1, t2);
  let t3;
  if ($[4] !== isLoading || $[5] !== stripeProducts) {
    t3 = {
      stripeProducts,
      isLoading
    };
    $[4] = isLoading;
    $[5] = stripeProducts;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  return t3;
}